<template lang="pug">
yz-dialog(v-model="dialogValue" persistent max-width="496")
  yz-card
    yz-dialog-normal-header(:title="`Cancel ${typeLabel}`" @close="onClose")
    .pa-6
      .d-flex.align-start
        v-icon.mr-3(color="danger500" size="24") $yzi-alert-circle
        div
          .yz-heading-8.neutral700--text Are you sure you want to cancel this {{ typeLabel }}?
          template(v-if="isPaid")
            .yz-regular-body-md.neutral700--text.mt-2 Some items have already been paid. You may issue a refund now or process it later. The selected items and quantities will be released back to available stock.
          template(v-else)
            .yz-regular-body-md.neutral700--text.mt-2 The selected items and quantities will be released back to available stock.
            .yz-regular-body-md.neutral700--text.mt-2 Click "Cancel {{ typeLabel }}" to proceed.
    yz-divider
    yz-card-actions.d-flex.align-center.justify-space-between.px-6.py-3
      yz-btn(size="lg" text text-color="yz-neutral-700" label="Cancel" @click="onClose")
      .d-flex(style="gap: 12px")
        yz-btn(size="lg" :label="`Cancel ${typeLabel}`" :loading="loading" color="danger" @click="onConfirm")
        yz-btn(v-if="isPaid" size="lg" label="Proceed with refund" :disabled="loading" dark @click="onRefund")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'reservation'
    },
    reservationData: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    typeLabel () {
      return this.type === 'reservation' ? 'reservation' : 'pre-order'
    },
    isPaid () {
      if (!this.reservationData) return false
      const status = this.reservationData.payment_status
      return status === 'paid' || status === 'partially_refunded'
    }
  },
  methods: {
    onClose () {
      this.dialogValue = false
    },
    onConfirm () {
      this.$emit('confirm')
    },
    onRefund () {
      this.$emit('refund')
    }
  }
}
</script>
